<div class="zx-max-100-vh h-100 w-100 d-flex flex-column flex-grow-1 overflow-auto">

    <div class="position-absolute w-100 d-flex zx-z-index-1" [class.justify-content-end]="isRTL">
        <button type="button" mat-icon-button aria-label="Toggle sidenav" (click)="closeRightPlaceDialog()"
            class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-3 w-100">
        <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode">
            {{ "right-place-title" | translate }}
        </h4>
        <p class="m-0 px-2 zx-text-medium w-100 text-center" [class.text-white]="isDarkMode" [class.zx-rtl]="!isRTL">
            {{ "right-place-explanation" | translate }}
        </p>

        <!-- spinner: -->
        <div *ngIf="isLoading" class="w-100 d-flex">
            <div class="step-item justify-content-center align-items-center w-100 rounded-3 shadow-85 d-flex p-2"
                [class.step-item-dark]="isDarkMode">
                <mat-spinner class="zx-small-plus-icon-size zx-medium-big-icon-size-lg"></mat-spinner>
            </div>
        </div>

        <!-- last branch btn: -->
        <div *ngIf="!isLoading"
            class="step-item-no-height step-item-hover d-flex flex-column flex-lg-row gap-2 rounded-3 p-3 w-100 shadow-85"
            matRipple [class.step-item-dark]="isDarkMode"
            [class.zx-step-choosen]="myBranchesList && branch === myBranchesList[0] && printingService === myPrintingServicesList[0]"
            (click)="onChooseServiceAndBranch(myPrintingServicesList[0] , myBranchesList[0])">
            <div class="d-flex w-100 align-items-center gap-3 gap-lg-4" [class.flex-row-reverse]="!isRTL">
                <img *ngIf="realBranchesObjectsSelected?.length > 0 && !isLoading && realBranchesObjectsSelected[0]?.name"
                    [class.bg-light-darkmode]="isDarkMode"
                    class="zx-medium-icon-size zx-big-icon-size-lg rounded-2 zx-border-gray-v-v-light shadow-85"
                    [src]="'assets/images/branches/' + realBranchesObjectsSelected[0]?.name + '.png'">
                <div class="d-flex flex-column gap-2">
                    <div class="d-flex align-items-center gap-3" [class.flex-row-reverse]="!isRTL">
                        <img *ngIf="myPrintingServicesList && myPrintingServicesList.length > 0  && !isLoading"
                            class="zx-small-plus-icon-size zx-medium-big-icon-size-lg"
                            [src]="'assets/images/'+ getPrintingService(0) + '-icon.svg'" alt="Printing Service Icon">
                        <p class="m-0 fw-bold"
                            *ngIf="myPrintingServicesList && myPrintingServicesList.length > 0 && !isLoading">
                            <span [class.text-white]="isDarkMode">{{ "choose-branch.naming." + myPrintingServicesList[0]
                                + '.' + myBranchesList[0] |
                                translate }}</span>
                            <span [class.text-white]="isDarkMode"> - </span>
                            <span [class.text-white]="isDarkMode">{{ "choose-branch.city." + myBranchesList[0] |
                                translate }}</span>
                        </p>
                    </div>
                    <div *ngIf="realBranchesObjectsSelected.length > 0 && !isLoading"
                        class="d-none d-lg-flex align-items-center gap-1" [class.flex-row-reverse]="!isRTL">
                        <span [class.text-white]="isDarkMode">{{ "paper-type.title" | translate }}</span>
                        <span [class.text-white]="isDarkMode">:</span>
                        <!-- 1st - papers desktop -->
                        <!-- plotter -->
                        <div class="d-flex align-items-center gap-1"
                            *ngIf="myPrintingServicesList[0] === 'plotter' && realBranchesObjectsSelected.length > 0">
                            <ng-container
                                *ngFor="let paper of realBranchesObjectsSelected[0].plotter.printers[0].inputBins; let j = index">
                                <div class="d-flex align-items-center">
                                    <span [class.text-white]="isDarkMode" [class.zx-rtl]="!isRTL"
                                        class="px-2 text-center">
                                        {{ "paper-type.name." + paper.paperType.paperType | translate }}
                                    </span>
                                    <span
                                        *ngIf="realBranchesObjectsSelected[0].plotter.printers[0].inputBins.length !== j + 1">
                                        ,
                                    </span>
                                </div>
                            </ng-container>
                        </div>
                        <!-- express -->
                        <div class="d-flex align-items-center gap-1"
                            *ngIf="myPrintingServicesList[0] === 'express' && realBranchesObjectsSelected.length > 0">
                            <ng-container
                                *ngFor="let paper of realBranchesObjectsSelected[0]?.express?.consumables?.papers; let j = index">
                                <div class="d-flex align-items-center">
                                    <span [class.text-white]="isDarkMode" [class.zx-rtl]="!isRTL"
                                        class="px-2 text-center">
                                        {{ "paper-type.name." + paper.serial_name | translate }}
                                    </span>
                                    <span
                                        *ngIf="realBranchesObjectsSelected[0]?.express.consumables.papers.length !== j + 1">
                                        ,
                                    </span>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex d-lg-none align-items-center" [class.flex-row-reverse]="!isRTL"
                *ngIf="realBranchesObjectsSelected.length > 0 && !isLoading">
                <span class="zx-text-tiny" [class.text-white]="isDarkMode">{{ "paper-type.title" | translate }}</span>
                <span class="zx-text-tiny px-1" [class.text-white]="isDarkMode">:</span>
                <!-- 1st - papers mobile -->
                <!-- plotter -->
                <div class="d-flex align-items-center gap-1"
                    *ngIf="myPrintingServicesList[0] === 'plotter' && realBranchesObjectsSelected.length > 0">
                    <ng-container
                        *ngFor="let paper of realBranchesObjectsSelected[0].plotter.printers[0].inputBins; let j = index">
                        <div class="d-flex align-items-center">
                            <span [class.text-white]="isDarkMode" [class.zx-rtl]="!isRTL"
                                class="px-2 text-center zx-text-tiny">
                                {{ "paper-type.name." + paper.paperType.paperType | translate }}
                            </span>
                            <span *ngIf="realBranchesObjectsSelected[0].plotter.printers[0].inputBins.length !== j + 1">
                                ,
                            </span>
                        </div>
                    </ng-container>
                </div>
                <!-- express -->
                <div class="d-flex align-items-center gap-1"
                    *ngIf="myPrintingServicesList[0] === 'express' && realBranchesObjectsSelected.length > 0">
                    <ng-container
                        *ngFor="let paper of realBranchesObjectsSelected[0].express?.consumables?.papers; let j = index">
                        <div class="d-flex align-items-center">
                            <span [class.text-white]="isDarkMode" [class.zx-rtl]="!isRTL"
                                class="px-2 text-center zx-text-tiny">
                                {{ "paper-type.name." + paper.serial_name | translate }}
                            </span>
                            <span *ngIf="realBranchesObjectsSelected[0].express.consumables.papers.length !== j + 1">
                                ,
                            </span>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <!-- dropdown section: -->
        <div *ngIf="myPrintingServicesList && myPrintingServicesList.length > 1 && !isLoading"
            class="w-100 position-relative top-0">
            <mat-accordion>
                <mat-expansion-panel>
                    <mat-expansion-panel-header [class.zx-flex-row-reverse]="!isRTL">
                        <span>{{ "right-place.more-right-places" | translate }}</span>
                    </mat-expansion-panel-header>

                    <div class="w-100 d-flex flex-column flex-lg-row rounded-3 p-0 w-100 p-1"
                        *ngFor="let thisBranch of myBranchesList.slice(1); let i = index">
                        <div matRipple
                            [class.zx-step-choosen]="myBranchesList && branch === myBranchesList[i+1] && printingService === myPrintingServicesList[i+1] "
                            class="d-flex step-item-no-height step-item-hover flex-column flex-lg-row gap-2 rounded-3 p-2 p-lg-3 w-100 shadow-85"
                            [class.step-item-dark]="isDarkMode" [class.step-item-dark]="isDarkMode"
                            (click)="onChooseServiceAndBranch(myPrintingServicesList[i+1] , myBranchesList[i+1])">
                            <div class="d-flex w-100 align-items-center gap-1 gap-lg-4"
                                [class.flex-row-reverse]="!isRTL">
                                <img *ngIf="realBranchesObjectsSelected.length > 0  && !isLoading"
                                    class="zx-medium-small-icon-size rounded-2 zx-border-gray-v-v-light shadow-85"
                                    alt="Branch Logo" [class.bg-light-darkmode]="isDarkMode"
                                    [src]="'assets/images/branches/' + realBranchesObjectsSelected[i+1].name + '.png'"
                                    realBranchesObjectsSelected>
                                <div class="d-flex flex-column gap-2">
                                    <div class="d-flex align-items-center gap-2" [class.flex-row-reverse]="!isRTL">
                                        <img *ngIf="myPrintingServicesList && myPrintingServicesList.length > 0  && !isLoading"
                                            class="zx-small-icon-size"
                                            [src]="'assets/images/'+ getPrintingService(i+1)  + '-icon.svg'"
                                            alt="Printing Service Icon">
                                        <p class="m-0 fw-bold"
                                            *ngIf="myPrintingServicesList && myPrintingServicesList.length > 0  && !isLoading">
                                            <span class="">
                                                {{ "choose-branch.naming." + myPrintingServicesList[i+1] + '.' +
                                                myBranchesList[i+1] | translate }}
                                            </span>
                                            <span class=""> - </span>
                                            <span class="">
                                                {{ "choose-branch.city." + myBranchesList[i+1] | translate }}
                                            </span>
                                        </p>
                                    </div>
                                    <div class="d-none d-lg-flex align-items-center gap-1"
                                        *ngIf="realBranchesObjectsSelected.length > 0 && !isLoading"
                                        [class.flex-row-reverse]="!isRTL">
                                        <span>{{ "paper-type.title" | translate }}</span>
                                        <span>:</span>
                                        <!-- 2+3+4st - papers desktop -->
                                        <!-- plotter -->
                                        <div class="d-flex align-items-center gap-1"
                                            *ngIf="myPrintingServicesList[i+1] === 'plotter' && realBranchesObjectsSelected.length > 0">
                                            <ng-container
                                                *ngFor="let paper of realBranchesObjectsSelected[i+1].plotter.printers[0].inputBins; let j = index">
                                                <div class="d-flex align-items-center">
                                                    <span [class.text-white]="isDarkMode" [class.zx-rtl]="!isRTL"
                                                        class="px-2 text-center">
                                                        {{ "paper-type.name." + paper.paperType.paperType | translate }}
                                                    </span>
                                                    <span
                                                        *ngIf="realBranchesObjectsSelected[i+1].plotter.printers[0].inputBins.length !== j + 1">
                                                        ,
                                                    </span>
                                                </div>
                                            </ng-container>
                                        </div>
                                        <!-- express -->
                                        <div class="d-flex align-items-center gap-1"
                                            *ngIf="myPrintingServicesList[i+1] === 'express' && realBranchesObjectsSelected.length > 0">
                                            <ng-container
                                                *ngFor="let paper of realBranchesObjectsSelected[i+1].express?.consumables?.papers; let j = index">
                                                <div class="d-flex align-items-center">
                                                    <span [class.text-white]="isDarkMode" [class.zx-rtl]="!isRTL"
                                                        class="px-2 text-center">
                                                        {{ "paper-type.name." + paper.serial_name | translate }}
                                                    </span>
                                                    <span
                                                        *ngIf="realBranchesObjectsSelected[i+1].express.consumables.papers.length !== j + 1">
                                                        ,
                                                    </span>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex d-lg-none align-items-center" [class.flex-row-reverse]="!isRTL"
                                *ngIf="realBranchesObjectsSelected.length > 0 && !isLoading">
                                <span class="zx-text-tiny">{{ "paper-type.title" | translate }}</span>
                                <span class="zx-text-tiny px-1">:</span>
                                <!-- 2+3+4st - papers mobile -->
                                <!-- plotter -->
                                <div class="d-flex align-items-center gap-1"
                                    *ngIf="myPrintingServicesList[i+1] === 'plotter' && realBranchesObjectsSelected.length > 0">
                                    <ng-container
                                        *ngFor="let paper of realBranchesObjectsSelected[i+1].plotter.printers[0].inputBins; let j = index">
                                        <div class="d-flex align-items-center">
                                            <span [class.text-white]="isDarkMode" [class.zx-rtl]="!isRTL"
                                                class="px-2 text-center zx-text-tiny">
                                                {{ "paper-type.name." + paper.paperType.paperType | translate }}
                                            </span>
                                            <span
                                                *ngIf="realBranchesObjectsSelected[i+1].plotter.printers[0].inputBins.length !== j + 1">
                                                ,
                                            </span>
                                        </div>
                                    </ng-container>
                                </div>
                                <!-- express -->
                                <div class="d-flex align-items-center gap-1"
                                    *ngIf="myPrintingServicesList[i+1] === 'express' && realBranchesObjectsSelected.length > 0">
                                    <ng-container
                                        *ngFor="let paper of realBranchesObjectsSelected[i+1].express?.consumables?.papers; let j = index">
                                        <div class="d-flex align-items-center">
                                            <span [class.text-white]="isDarkMode" [class.zx-rtl]="!isRTL"
                                                class="px-2 text-center zx-text-tiny">
                                                {{ "paper-type.name." + paper.serial_name | translate }}
                                            </span>
                                            <span
                                                *ngIf="realBranchesObjectsSelected[i+1].express.consumables.papers.length !== j + 1">
                                                ,
                                            </span>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>

                </mat-expansion-panel>
            </mat-accordion>
        </div>

        <div class="d-flex flex-grow-1 justify-content-center align-items-end w-100 pt-3">
            <button color="primary" (click)="goHome()" mat-stroked-button [class.bg-light-darkmode-light]="isDarkMode"
                class="rounded-pill zx-btn-single w-100 zx-text-black">
                <div class="d-flex align-items-center justify-content-center c-pointer gap-2"
                    [class.flex-row-reverse]="!isRTL">
                    <img *ngIf="!isDarkMode" src="assets/images/chainge-icon.svg"
                        class="svg zx-small-icon-size c-pointer d-flex">
                    <img *ngIf="isDarkMode" src="assets/images/chainge-icon-green.svg"
                        class="svg zx-small-icon-size c-pointer d-flex">
                    <span class="c-pointer" [class.text-green]="isDarkMode" [class.zx-text-tiny]="!isDarkMode"
                        [class.zx-text-small]="isDarkMode">
                        {{ "choose-branch.back-to-last-step" | translate }}
                    </span>
                </div>
            </button>
        </div>

    </div>
</div>